import React from 'react'
import {broadcast, listen, stop_listen, post_gql, create_attach, chat_layer, makeid, IS_DEV} from '../../utils'
import './index.css'

const utilizeFocus = () => {
    const ref = React.createRef()
    const setFocus = () => {ref.current &&  ref.current.focus()}
    return {setFocus, ref}
}

const utilizeFocusMessage = () => {
    const ref = React.createRef()
    const setFocus = () => {ref.current &&  ref.current.focus()}
    const setClear = () => {
      if (ref.current)
        ref.current.innerHTML = ""
    }
    return {setFocus, ref, setClear}
}

const bytes_to_str = (bytes) => {
  if (bytes < 1024)
    return(`${bytes}б`)

  if (bytes < 1024 * 1024)
    return(`${Math.round(bytes / 1024, 2)}Кб`)

  if (bytes < 1024 * 1024 * 1024)
    return(`${Math.round(bytes / (1024*1024), 2)}Мб`)

  return(`${Math.round(bytes / (1024*1024* 1024), 2)}Гб`)
}

const scroolRef = () => {
    const ref = React.createRef()
    const scroll = () => {
      if (ref.current){
        setTimeout(() => ref.current.scrollTop = ref.current.scrollHeight, 300)
      }
    }
    return {scroll, ref}
}

class Chat extends React.Component {
  constructor(props) {
    super(props)

    const origin = window.location.origin.replace("3000", "4000")

    var back_url = `${origin.replace("http://", "http://back.")}`

    if (IS_DEV)
      back_url = `${origin}`

    this.state = {
      mode: 'cursor',
      token: "",
      back_url: back_url,
      mouse_down_coords: false,
      container_mouse_coords: false,
      edit_layer_id: false,
      creating_coords: false,
      creating_coordinates: false,
      creating_input: null,
      creating_id: false,
      file_upload_progress: false,
      img: false,
      top: 10,
      left: 30,
      chat_settings: {title: "", picture: "", user_id: "-1"},
      current_message_text: "",
      messages: [],
      user_id: false,
      users: {},
      hidden: false,
      listners: []
    }

    this.inputFocus = utilizeFocus()
    this.inputFocusMessage = utilizeFocusMessage()
    this.scroolRef = scroolRef()
  }

  componentDidUpdate(prevProps, prevState){
    if (prevState.creating_coords !== this.state.creating_coords && !!this.state.creating_coords)
      this.inputFocus.setFocus()

    if (prevState.messages.length !== this.state.messages.length){
      this.inputFocusMessage.setFocus()

      const last_m = this.state.messages[this.state.messages.length-1]
      if (last_m && last_m.user_id === `${prevProps.user_id}`){
        this.inputFocusMessage.setClear()
      }
      this.scroolRef.scroll()
    }

    if (!prevState.edit_layer_id && !!this.state.edit_layer_id)
      this.scroolRef.scroll()

    if (prevState.hidden !== this.state.hidden)
      this.scroolRef.scroll()
  }

  componentDidMount(){
    const listners = [
      {type: "containter_onMouseMove", fnc: ({detail}) => {
        this.setState({container_mouse_coords: [detail.clientX, detail.clientY]})
        if (!!this.state.mouse_down_coords)
          this.setState({
            top: this.state.top + (detail.clientY - this.state.mouse_down_coords[1]),
            left: this.state.left + (detail.clientX - this.state.mouse_down_coords[0]),
            mouse_down_coords: [detail.clientX, detail.clientY]
          })
      }},
      {type: "toolbar_mode_change", fnc: ({detail}) => {
        this.setState({mode: detail.mode, edit_layer_id: false, messages: []})
      }},
      {type: "remove_layer", fnc: ({detail}) => {
        if (detail === this.state.edit_layer_id)
          this.setState({edit_layer_id: false, messages: []})
      }},
      {type: "toolbar_delete", fnc: ({detail}) => {
        if (this.state.edit_layer_id) {
          post_gql(
            `mutation {geomapLayerDelete(layer_id: ${this.state.edit_layer_id})}`,
            resp => {
              broadcast("remove_layer", this.state.edit_layer_id)
              broadcast("toolbar_mode_change", {mode: 'cursor'})
              broadcast("layer_edit", {id: false, type: "chat"})
            }
          )
        }
      }},
      {type: "current_user", fnc: ({detail}) => this.setState({
        chat_settings: {...this.state.chat_settings, picture: detail.picture},
        token: detail.access_token
      })},
      {type: "map_click", fnc: ({detail}) => {
        if (this.state.creating_id)
          broadcast("remove_layer", this.state.creating_id)

        const obj = detail.event.object

        if (detail.mode === "cursor" && obj && !obj.bbox && !!obj.properties.chat_settings) {

          post_gql(
            `query {
                chatMessagesGet(
                  geomap_id: "${window.location.pathname.replace("/t/", "")}",
                  chat_id: ${obj.properties.id}
                ){id text time user_id chat_attachs {id name type}}

                chatGetUsers(
                  geomap_id: "${window.location.pathname.replace("/t/", "")}",
                  chat_id: ${obj.properties.id}
                ){id name picture}
            }`,
            resp => {
              var users = {}
              resp.data.data.chatGetUsers.forEach(u => {users[u.id] = u})
              var top = detail.event.pixel[1]

              if (top + 600 > detail.event.viewport.height)
                top = detail.event.viewport.height - 600

              this.setState({
                edit_layer_id: obj.properties.id,
                chat_settings: obj.properties.chat_settings,
                top: top,
                left: detail.event.pixel[0],
                messages: resp.data.data.chatMessagesGet,
                users: users
              })

              broadcast("layer_edit", {id: obj.properties.id, type: "chat"})
            },
            {"authorization": `Bearer ${this.state.token}`}
          )
        } else {
          if (detail.mode === "chat") {
            var creating_coords_top = detail.event.pixel[1] - 22
            var creating_coords_left = detail.event.pixel[0] + 20

            if (creating_coords_top < 30)
              creating_coords_top = 30

            if (creating_coords_top > detail.event.viewport.height - 30)
              creating_coords_top = detail.event.viewport.height - 30

            if (creating_coords_left < 30)
              creating_coords_left = 30

            if (creating_coords_left > detail.event.viewport.width - 300)
              creating_coords_left = creating_coords_left - 300

            const creating_id = makeid(10)

            this.setState({
              creating_coords: [creating_coords_top, creating_coords_left],
              creating_coordinates: detail.event.coordinate,
              chat_settings: this.state.chat_settings,
              creating_id: creating_id
            })

            chat_layer(
              detail.event.coordinate,
              {id: creating_id, chat_settings: this.state.chat_settings}
            ).forEach(l => broadcast("add_or_replace_layer", l))
          }
        }
      }},

      {type: "chat_title", fnc: ({detail}) => this.setState({chat_settings: {...this.state.chat_settings, title: detail.value}})},
      {type: "current_message_text", fnc: ({detail}) => this.setState({current_message_text: detail.value})},
      {type: "update_chat_title", fnc: ({detail}) => this.setState({chat_settings: {...this.state.chat_settings, title: detail.value}})},
      {type: "message_created", fnc: ({detail}) => {
        const m = detail.message

        if (this.state.edit_layer_id === m.chat_id){
          const u = detail.user
          const users = {...this.state.users}
          users[u.id] = u
          this.setState({messages: [...this.state.messages, m], users: users})

          post_gql(
            `mutation { updateLastRead(
              geomap_id: "${window.location.pathname.replace("/t/", "")}",
              chat_id: ${this.state.edit_layer_id},
              message_id: ${m.id}
            )}`,
            resp => null,
            {"authorization": `Bearer ${this.state.token}`}
          )
        }
      }},

    ]

    listners.forEach(l => listen(l.type, l.fnc))
    this.setState({listners})
  }

  componentWillUnmount(){this.state.listners.forEach(l => stop_listen(l.type, l.fnc))}

  render() {
    if (this.state.mode === 'chat' && !!this.state.creating_coords){
      return(
        <div
          className="polygon-tool"
          style={{
            position: "absolute",
            top: this.state.creating_coords[0],
            left: this.state.creating_coords[1],
            width: "250px",
            backgroundColor: "#ffffff"
          }}
        >
          <div className="tool-header">
            <span className="tool-header-title">&nbsp;новый чат</span>
            <div className="tool-header-btns">
              <span className="tool-header-btn" >{" "}</span>
              <span
                className="tool-header-btn"
                style={{transform: `rotateZ(45deg)`}}
                onClick={() => {
                  if (this.state.creating_id)
                    broadcast("remove_layer", this.state.creating_id)

                  this.setState({
                    creating_coords: false,
                    creating_coordinates: false,
                    chat_settings: {title: "", picture: this.state.chat_settings.picture},
                    creating_id: false
                  })
                }}
              >+</span>
            </div>
          </div>

          <div className="tool-body">
            <div className="tool-input-cont">
              <div
                style={{border: "ridge 2px", padding: "5px", width: "100%", minHeight: "2em", overflow: "auto"}}
                onInput={e => broadcast(!!this.state.edit_layer_id ? "update_chat_title" : "chat_title", {object_id: this.state.edit_layer_id, user_id: this.props.user_id, value: e.currentTarget.innerHTML})}
                contentEditable
                ref={this.inputFocus.ref}
                onKeyDown={e => {
                  if (e.keyCode === 13 && !e.shiftKey){
                    post_gql(
                      `mutation { geomapLayerCreate(
                          geomap_id: "${window.location.pathname.replace("/t/", "")}",
                          user_id: "${this.props.user_id}",
                          type: CHAT,
                          point_coords: ${JSON.stringify(this.state.creating_coordinates)},
                          chat_settings: {
                            title: ${JSON.stringify(this.state.chat_settings.title)},
                            picture: ${JSON.stringify(this.state.chat_settings.picture)}
                          }
                        ){id user_id point_coords type chat_settings {title picture status created_at}
                      }}`,
                      resp => {
                        const props = resp.data.data.geomapLayerCreate
                        chat_layer(props.point_coords, props).forEach( l => broadcast("add_or_replace_layer", l))
                        if (this.state.creating_id)
                          broadcast("remove_layer", this.state.creating_id)
                        this.setState({
                          creating_coords: false,
                          creating_coordinates: false,
                          chat_settings: {title: "", picture: this.state.chat_settings.picture},
                          creating_id: false
                        })
                      },
                      {"authorization": `Bearer ${this.state.token}`}
                    )
                  }
                }}
              />
            </div>
          </div>
        </div>
      )
    } else {
      if (!!this.state.edit_layer_id) {
        return(
          [
            this.state.img ?
              <img
                key={`img_full_${this.state.img.id}`}
                onClick={() => this.setState({img: false})}
                alt="img"
                style={{
                  position: 'absolute',
                  top: "50px",
                  right: "10px",
                  cursor: 'pointer',
                  border: '1px solid #8a8a8a',
                  maxWidth: '50vw',
                  maxHeight: '50vh'
                }}
                src={`${this.state.back_url}/attach?id=${this.state.img.id}`}
              /> : null,
            <div
              key={`chat_${this.state.edit_layer_id}`}
              className="polygon-tool"
              style={{
                top: this.state.top,
                left: this.state.left,
                width: "400px"
              }}
            >
              <div
                className="tool-header"
                onMouseDown={e => this.setState({mouse_down_coords: this.state.container_mouse_coords})}
                onMouseUp={e => this.setState({mouse_down_coords: false})}
              >
                <span className="tool-header-title">&nbsp;чат</span>
                <span
                  className="chat-archive-btn"
                  onClick={() => {
                    post_gql(
                      `mutation { chatArchive(chat_id: ${this.state.edit_layer_id})}`,
                      resp => {
                        broadcast("remove_layer", this.state.edit_layer_id)
                        broadcast("toolbar_mode_change", {mode: 'cursor'})
                        broadcast("layer_edit", {id: false, type: "chat"})
                      },
                      {"authorization": `Bearer ${this.state.token}`}
                    )
                  }}
                >в архив</span>
                <div className="tool-header-btns">
                  <span
                    className="tool-header-btn"
                    onClick={() => this.setState({hidden: !this.state.hidden})}
                  >{this.state.hidden ? "▾" : "▸"}</span>
                  <span
                    className="tool-header-btn"
                    style={{transform: `rotateZ(45deg)`}}
                    onClick={() => {
                      broadcast("toolbar_mode_change", {mode: 'cursor'})
                      broadcast("layer_edit", {id: false, type: "chat"})
                    }}
                  >+</span>
                </div>
              </div>
              {
                this.state.hidden ? null : <div
                  ref={this.scroolRef.ref}
                  className="chat-messages-cont"
                >
                  {
                    this.state.messages.map( (m, m_i) => {
                      const date = new Date(m.time * 1000)
                      const day = parseInt(date.toLocaleString().slice(0,2))
                      const day_w = ["вс", "пн", "вт", "ср", "чт", "пт", "сб"][date.getDay()]
                      const month = ["янв", "фев", "мар", "апр", "май", "июн", "июл", "авг", "сен", "окт", "ноя", "дек"][date.getMonth()]
                      const time = date.toLocaleTimeString().slice(0,5)

                      var show_header = true
                      const prev_m = this.state.messages[m_i-1]

                      if (prev_m && prev_m.user_id === m.user_id && (Math.floor(m.time / 60) === Math.floor(prev_m.time / 60)) ){
                        show_header = false
                      }

                      return(
                        <div
                          className="chat-message"
                          key={`message_${this.state.edit_layer_id}_${m.id}`}
                        >
                          {
                            show_header && <div className="chat-message-header">
                              <div className="chat-message-header-user">
                                <img
                                  alt=""
                                  className="chat-message-header-img"
                                  src={this.state.users[m.user_id].picture}
                                />
                                <span className="chat-message-header-username">
                                  {this.state.users[m.user_id].name}
                                </span>
                              </div>
                              <span className="chat-message-header-date">
                                {`${time} ${day_w} ${day} ${month}`}
                              </span>
                            </div>
                          }
                          {
                            m.chat_attachs[0] ? <div
                                className="chat-message-body"
                                style={{
                                  display: 'flex',
                                  flexWrap: 'wrap',
                                  flexDirection: 'row'
                                }}
                              >
                                {
                                  m.chat_attachs.map((attach, i) => {
                                    if (attach.type === "png" || attach.type === "jpg" || attach.type === "jpeg" || attach.type === "gif") {
                                      return(
                                        <img
                                          onClick={() => {
                                            if (!this.state.img || this.state.img.id !== attach.id){
                                              this.setState({img: attach})
                                            } else {
                                              this.setState({img: false})
                                            }
                                          }}
                                          key={`m_img_${attach.id}`}
                                          alt="img"
                                          className="chat-message-body-img"
                                          src={`${this.state.back_url}/attach?id=${attach.id}&resized=true`}
                                        />
                                      )
                                    } else {
                                      return(
                                        <a
                                          style={{marginTop: "4px", marginLeft: "4px", width: '320px'}}
                                          key={`m_file_${attach.id}`}
                                          href={`${this.state.back_url}/attach?id=${attach.id}`}
                                        >{attach.name}</a>
                                      )
                                    }
                                  })
                                }
                              </div> : <div className="chat-message-body"
                                dangerouslySetInnerHTML={{__html: m.text}}
                              >
                              </div>
                          }
                        </div>
                      )
                    })
                  }
                </div>
              }

              {this.state.hidden ? null :
                <div
                  style={{
                    display: "flex",
                    width: "374px",
                    padding: "2px 12px",
                    justifyContent: "space-between",
                    border: "1px solid rgba(224, 228, 235)",
                    borderTop: "0px",
                    borderBottom: "0px"
                  }}
                >
                  <img
                    alt=""
                    className="chat-message-header-img"
                    src={this.state.users[this.props.user_id].picture}
                  />
                  <div
                    style={{border: "1px solid #8a8a8a", padding: "5px", width: "330px", minHeight: "15px", overflow: "auto"}}
                    onInput={e => broadcast(!!this.state.edit_layer_id ? "current_message_text" : "current_message_text", {object_id: this.state.edit_layer_id, user_id: this.props.user_id, value: e.currentTarget.innerHTML})}
                    contentEditable
                    ref={this.inputFocusMessage.ref}
                    onKeyDown={e => {
                      if (e.keyCode === 13 && !e.shiftKey){
                        post_gql(
                          `mutation { chatMessageCreate(
                              geomap_id: "${window.location.pathname.replace("/t/", "")}",
                              chat_id: ${this.state.edit_layer_id},
                              text: ${JSON.stringify(this.state.current_message_text)},
                              attachment_ids: []
                            ){id text time user_id chat_attachs {id name type}
                          }}`,
                          resp => {
                            const props = resp.data.data.chatMessageCreate
                            this.setState({messages: [...this.state.messages, props], current_message_text: ""})
                          },
                          {"authorization": `Bearer ${this.state.token}`}
                        )
                      }
                    }}
                  />
                </div>
              }

              {this.state.hidden ? null :
                  <input
                    style={{
                      width: "354px", paddingLeft: '44px',  border: "1px solid rgb(224, 228, 235)", borderTop: "0px",
                      paddingBottom: "4px", paddingTop: "4px"
                    }}
                    type="file"
                    multiple
                    value={[]}
                    onChange={(e) => {
                      var formData = new FormData();
                      const len = e.target.files.length
                      for (var i=0; i < len; i++){
                        formData.append(`file_${i}`, e.target.files[i])
                      }

                      create_attach(
                        formData,
                        resp => {
                          post_gql(
                            `mutation { chatMessageCreate(
                                geomap_id: "${window.location.pathname.replace("/t/", "")}",
                                chat_id: ${this.state.edit_layer_id},
                                text: "",
                                attachment_ids: ${JSON.stringify(resp.data.map(v => v.id))}
                              ){id text time user_id chat_attachs {id name type}
                            }}`,
                            resp => {
                              const props = resp.data.data.chatMessageCreate
                              this.setState({
                                messages: [...this.state.messages, props],
                                current_message_text: "",
                                file_upload_progress: false
                              })
                            },
                            {"authorization": `Bearer ${this.state.token}`}
                          )
                        },
                        {"authorization": `Bearer ${this.state.token}`},
                        (e) => this.setState({
                          file_upload_progress:
                            {loaded: e.loaded, total: e.total, progress: e.progress}
                        }),
                        (e) => {
                          this.setState({file_upload_progress: false})
                          alert(e);
                        }
                      )
                    }}
                  />
                }
                {
                  this.state.file_upload_progress ? <div
                    style={{
                      width: "340px",
                      position: 'relative',
                      fontFamily: "monospace",
                      paddingLeft: '44px',
                      paddingRight: '14px',
                      border: "1px solid rgb(224, 228, 235)", borderTop: "0px",
                      paddingBottom: "4px", paddingTop: "4px"
                    }}
                  >
                    <div style={{
                      width: `${this.state.file_upload_progress.progress * 340}px`,
                      position: 'absolute',
                      minHeight: '100%',
                      top: "0px",
                      height: '100%',
                      backgroundColor: "rgba(0, 0, 0, 0.2)"
                    }}></div>
                    {
                      `${bytes_to_str(this.state.file_upload_progress.loaded)} / ${bytes_to_str(this.state.file_upload_progress.total)}`
                    }
                  </div> : null
                }
              </div>
        ]
        )
      } else {
        return(null)
      }
    }
  }
}

export default Chat;
